import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UFileUploadComponent } from './u-file-upload.component';
import { UButtonModule } from '../u-button/u-button.module';
import { UiInfraModule } from '../../ui-infra.module';

@NgModule({
  declarations: [UFileUploadComponent],
  imports: [CommonModule, UButtonModule, UiInfraModule],
  exports: [UFileUploadComponent],
})
export class UFileUploadModule {}
